// frontend/src/hooks/useErrorNotification.ts
import { useCallback } from 'react';
import { toast } from 'react-hot-toast';
import { ApplicationError } from '../types/error.types';

export const useErrorNotification = () => {
  const showError = useCallback((error: ApplicationError) => {
    // Log error for debugging
    console.error(`[${error.code}] ${error.message}`, error.details);
    
    // Show user-friendly toast notification
    toast.error(error.message, {
      duration: 4000,
      position: 'top-right',
    });
  }, []);

  return { showError };
};